import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('login'); // 'login' | 'register'

  const refresh = useCallback(async () => {
    const tok = localStorage.getItem('cv_token');
    if (!tok) { setUser(null); setLoading(false); return; }
    try {
      const u = await api.me();
      setUser(u);
    } catch (_) {
      localStorage.removeItem('cv_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async ({ email, password }) => {
    const res = await api.login({ email, password });
    localStorage.setItem('cv_token', res.access_token);
    setUser(res.user);
    return res.user;
  };

  const register = async (data) => {
    const res = await api.register(data);
    // Compte enseignant en attente de validation par l'admin — pas d'auto-login
    if (res.user?.status === 'pending') {
      return { pending: true, user: res.user };
    }
    localStorage.setItem('cv_token', res.access_token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem('cv_token');
    setUser(null);
  };

  const openLogin = () => { setModalMode('login'); setModalOpen(true); };
  const openRegister = () => { setModalMode('register'); setModalOpen(true); };
  const closeModal = () => setModalOpen(false);

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, modalOpen, modalMode, openLogin, openRegister, closeModal, setModalMode }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
